<template>
  <div>
    <div>
      <hr />
    </div>
    <section class="px-5 py-20 text-gray-600 md:px-0">
      <div class="w-full mb-10 lg:w-1/2">
        <h1
          class="mb-2 text-2xl font-bold text-gray-900 sm:text-3xl title-font"
        >
          {{ $t("principles-of-development") }}
        </h1>
        <div class="w-20 h-1 rounded bg-primary-green"></div>
      </div>
      <div
        class="grid grid-cols-1 gap-5 px-5 py-8 mx-auto text-gray-700 bg-gray-100 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3"
      >
        <div class="h-auto" v-for="principle in principles" :key="principle.id">
          <img
            :src="getBaseUrl() + principle.Image.url"
            :alt="principle.Title"
            class="h-24 mb-4"
          />
          <h2 class="mb-2 text-lg font-bold">{{ principle.Title }}</h2>
          <p class="leading-relaxed">{{ principle.Description }}</p>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from "axios";
import { baseUrl } from "../Api";
import { mapGetters } from "vuex";

export default {
  name: "Principles",
  data() {
    return {
      principles: [],
      error: null,
    };
  },
  computed: {
    ...mapGetters({
      lang: "LanguageStore/lang",
      api: "LanguageStore/apiPrinciples",
    }),
  },
  watch: {
    async lang() {
      this.loading = true;
      await this.getData();
    },
  },
  methods: {
    getBaseUrl() {
      return baseUrl;
    },
    async getData() {
      try {
        const response = await axios.get(this.api);
        this.principles = response.data;
        this.loading = false;
      } catch (error) {
        this.error = error;
      }
    },
  },
  async created() {
    await this.getData();
  },
};
</script>
<style scoped>
hr {
  background: linear-gradient(217deg, #d76738, rgba(255, 0, 0, 0) 70.71%),
    linear-gradient(127deg, #4aa350, rgba(0, 255, 0, 0) 70.71%);
  transition: width 0.35s;
  height: 1px;
  border-top-width: 0 !important;
}
</style>
